import type { Tracker } from '@archipro-website/tracker';
import type { CreateEnquirySource } from '~/modules/enquiry';

interface CreatedEnquiryProps {
    source: CreateEnquirySource;
    isMemberGenerated?: boolean;
    /**
     * The professional being enquired with. Required for the enquiry to count
     * towards that client's advertising conversions rather than only site-wide
     * ones.
     */
    professionalId?: number;
}

export const trackCreatedEnquiry = (
    tracker: Tracker,
    props: CreatedEnquiryProps,
) => {
    const { source, isMemberGenerated, professionalId } = props;
    tracker.log('CreatedEnquiry', {
        url: new URL(window.location.href),
        professionalId,
        data: {
            Source: source,
            ProfessionalID: professionalId,
            ExtraData: isMemberGenerated ? 'memberGenerated' : undefined,
        },
    });
};
